import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import config from '@/config/index';
import $axios from '@/service/httpServer';
import ElementUI from 'element-ui';
import '@/common/styles/element-variables.scss'; // 自定义 element-ui 主题
import '@/common/styles/common.scss'; // 自定义 css

import containerWrap from '@/components/layoutComponents/containerWrap';
import containerCol from '@/components/layoutComponents/containerCol';
import containerRow from '@/components/layoutComponents/containerRow';
Vue.component(containerWrap.name, containerWrap);
Vue.component(containerCol.name, containerCol);
Vue.component(containerRow.name, containerRow);
// 公共utils
import AES from '@/common/js/secret';
import { Base64 } from 'js-base64';
import * as mUtils from '@/common/js/mUtils';
import { getAppCodeByName } from './modules-config';

// api
import * as API from '@/api/index';

// 注册全局共享变量
import registerGlobal from './registerGlobal';

import NhComponents from './comonComponents';

import _ from 'lodash';

import NsTrack from "./track"
import getUserInfo from "@/common/js/userInfo"

Vue.use(NsTrack, {
  appCode: process.env.VUE_APP_TRACK_APP_CODE,
  global: true,
  url: process.env.VUE_APP_TRACK_URL,
  userInfo: getUserInfo
})
// lodash
window._ = _;

Vue.use(ElementUI, { size: 'small' });


Vue.config.productionTip = false;

Vue.config.silent = true;

// 挂载全局方法
Vue.prototype.$api = API;
Vue.prototype.$API = API;
Vue.prototype.AES = AES;
Vue.prototype.$base64 = Base64;
Vue.prototype.$mUtils = mUtils;
Vue.prototype.$axios = $axios;
/**
 * 公共配置信息
 */
Vue.prototype.$config = config;

// 全局命名空间
window._Newhope = {};

// _Newhope
registerGlobal(window._Newhope, {
  store,
  router,
  $axios,
  Vue,
  $API: API,
  $mUtils: mUtils,
  getAppCodeByName, // 获取appCode
  NhComponents,
  AES,
});

String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
